export const cognitoConfig = {
	region: ((import.meta as any).env.VITE_COGNITO_REGION as string) || 'sa-east-1',
	userPoolId: ((import.meta as any).env.VITE_COGNITO_USER_POOL_ID as string) || 'sa-east-1_C2PZv7Jf7',
	clientId: ((import.meta as any).env.VITE_COGNITO_CLIENT_ID as string) || '4uqcoqsdu57v89igvm4uijjsri',
	clientSecret: ((import.meta as any).env.VITE_COGNITO_CLIENT_SECRET as string) || 'qq9tvrri29vmuseid8bf061da723kemgf8r9s8hbemehr7trgfm'
};

export const isCognitoConfigured = (): boolean => {
	return Boolean(cognitoConfig.region && cognitoConfig.userPoolId && cognitoConfig.clientId);
};